var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-form-item',[_c('a-cascader',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'userid',
        {rules: [{ required: true, message: _vm.handoverPlace }], initialValue: _vm.val}
      ]),expression:"[\n        'userid',\n        {rules: [{ required: true, message: handoverPlace }], initialValue: val}\n      ]"}],staticClass:"p-select",attrs:{"field-names":{ label: 'name', value: 'id', children: 'children' },"options":_vm.selectList,"placeholder":_vm.title},on:{"change":_vm.onChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }